
import * as React from "react";

import {
    Grid,
} from "tabler-react";
import Wanted from '../component/Wanted';
import Message from '../component/IntroMessage';

interface HelloMessageProps {
}

export default class Home extends React.Component<HelloMessageProps, {}>{
    render() {
        return (<Grid.Row>
            <Grid.Col width={12} md={6} lg={4} xl={5}>
                <Message />
            </Grid.Col>
            <Grid.Col width={12} md={6} lg={8} xl={7}>
                <Wanted />
            </Grid.Col>
        </Grid.Row>);
    }
}